import { NAME } from './constants';

export const CLEAR_ERROR = `${NAME}/CLEAR_ERROR`;
export const LOAD_DETAILS_BY_CODE = `${NAME}/LOAD_DETAILS_BY_CODE`;
export const LOAD_DETAILS_SUCCESS = `${NAME}/LOAD_DETAILS_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
export const SET_AIRPORT = `${NAME}/SET_AIRPORT`;
export const SET_SECONDARY_ACTION = `${NAME}/SET_SECONDARY_ACTION`;
